"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SvgIcon_1 = require("../SvgIcon");
var Provider_1 = require("../Provider");
exports.StemIcon = function (props) { return (React.createElement(Provider_1.ErgoElementsContext.Consumer, null, function (context) {
    var idGenerator = context.idGenerator;
    return (React.createElement(SvgIcon_1.default, { idGenerator: idGenerator, viewBox: "0 0 20 21", width: 20, height: 11, className: props.className },
        React.createElement("polyline", { points: "0,11 0,10 10,1 20,10 20,11", strokeWidth: "0", fill: "white" }),
        React.createElement("path", { d: "M0 10 L10 1 L20 10", stroke: "black", strokeLinecap: "butt", strokeWidth: "1", fill: "none" })));
})); };
exports.default = exports.StemIcon;
//# sourceMappingURL=StemIcon.js.map
